// ==================== IMPORTS ====================
import { toast } from "react-toastify";
import "./InfluenceAuctionListPage.scss";
import ReactPaginate from "react-paginate";
import React, { useEffect, useState } from "react";
import { Modal, Nav, Tab, Table } from "react-bootstrap";
import { CrossIcon, StarIcon } from "../../../Assets/svgIcons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../components/loading/loading.component";
import { CMAuctions } from "../../Public/billing-history/billing-history.styles";
import InviteExternalInfluencer from "./InviteExternalInfluencer/InviteExternalInfluencer";
import {
  createInfluencerInvitation,
  getAcceptedInfluencer,
  getActiveInfluencer,
  inviteAllInfleuencerV2,
} from "../../../Services/prod/auth.service";

const InfluenceAuctionListPage = () => {
  // ==================== STATES ====================
  const limit = 10;
  const navigate = useNavigate();
  const { state } = useLocation();
  const auctionId = state?.auctionId;
  const auctionName = state?.auctionName;
  const [show, setShow] = useState(false);
  const [pageAll, setPageAll] = useState(1);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [pageInfluencer, setPageInfluencer] = useState(1);
  const [selectedInfluencer, setSelectedInfluencer] = useState([]);
  const [activeInfluencer, setActiveInfluencer] = useState({
    rows: [],
    count: 0,
  });
  const [acceptedInfluencer, setAcceptedInfluencer] = useState({
    outerData:{},
    rows: [],
    count: 0,
  });

  // ==================== GET ACTIVE INFLUENCER LIST ====================
  useEffect(() => {
    const activeInfluencerList = async () => {
      try {
        if (activeTab === "all") {
          const activeInfluencerRes = await getActiveInfluencer(
            pageAll,
            limit,
            auctionId
          );
          if (
            activeInfluencerRes?.status === 200 ||
            activeInfluencerRes?.status === 201
          ) {
            setLoading(false);
            setActiveInfluencer({
              rows: activeInfluencerRes?.data?.rows,
              count: activeInfluencerRes?.data?.count,
            });
          }
          else{
            setLoading(false);
          }
        } else {
          const acceptedInfluencerRes = await getAcceptedInfluencer(
            pageInfluencer,
            limit,
            auctionId
          );
          if (
            acceptedInfluencerRes?.status === 200 ||
            acceptedInfluencerRes?.status === 201
          ) {
            setLoading(false);
            setAcceptedInfluencer({
              outerData: acceptedInfluencerRes?.data,
              rows: acceptedInfluencerRes?.data?.rows,
              count: acceptedInfluencerRes?.data?.count,
            });
          }
          else{
            setLoading(false);
          }
        }
      } catch (error) {
        setLoading(false);
        console.log(error, "ERROR");
      }
    };
    activeInfluencerList();
  }, [update, activeTab, pageAll, pageInfluencer]);

  // ==================== CREATE INFLUENCER INVITATION {SINGLE} ====================
  const handleInviteSingle = async (data) => {
    try {
      const invitePayload = {
        data: [
          {
            invited_to: data?.user_id,
            invited_to_name: data?.name,
            fee: data?.fee,
          },
        ],
        auction_id: auctionId,
        auction_name: auctionName,
      };
      console.log("comming", invitePayload);
      const inviteRes = await createInfluencerInvitation(invitePayload);
      if (inviteRes?.status === 200 || inviteRes?.status === 201) {
        setUpdate(!update);
        setModalOpen(false);
        toast.success(inviteRes?.message);
      }
      else {
        setModalOpen(false);
        toast.error(inviteRes?.message);
        console.log(inviteRes, "Create Influencer Api Error");
      }
    } catch (error) {
      setModalOpen(false);
      console.log("Error in CreateInfluencer Api", error);
    }
  };

  // ==================== CREATE INFLUENCER INVITATION {SELECTED} ====================
  const handleInviteSelected = (e, data) => {
    try {
      const isChecked = e.target.checked;
      const influencerIndex = selectedInfluencer?.findIndex(
        (item) => item.invited_to === data.user_id
      );
      let updatedSelectedInfluencer = [...selectedInfluencer];
      if (isChecked) {
        // Add influencer if selected and not already present
        if (influencerIndex === -1) {
          updatedSelectedInfluencer = [
            ...updatedSelectedInfluencer,
            {
              invited_to: data.user_id,
              invited_to_name: data.name,
              fee: data.fee,
            },
          ];
        }
      } else {
        // Remove influencer if unchecked
        if (influencerIndex !== -1) {
          updatedSelectedInfluencer = updatedSelectedInfluencer?.filter(
            (item) => item.invited_to !== data.user_id
          );
        }
      }
      setSelectedInfluencer(updatedSelectedInfluencer);
    } catch (error) {
      console.log(error, "error");
    }
  };

  // ==================== HANDLE SELECT ALL ====================
  const handleSelectAll = () => {
    try {
      let updatedSelectedInfluencer = [];
      updatedSelectedInfluencer = activeInfluencer?.rows
        ?.filter((data) => data?.invitationStatus === null)
        ?.map((data) => ({
          invited_to: data?.user_id,
          invited_to_name: data?.name,
          fee: data?.fee,
        }));
      setSelectedInfluencer(updatedSelectedInfluencer);
    } catch (error) {
      console.log(error, "error in select all");
    }
  };

  // ==================== ONLY FOR INVITE SELECTED AND INVITE ALL  ====================
  const handleInvite = async (status) => {
    try {
      let updatedSelectedInfluencer = [];
      if (status === "INVITE-ALL") {
        updatedSelectedInfluencer = activeInfluencer?.rows
          ?.filter((data) => data?.invitationStatus === null)
          ?.map((data) => ({
            invited_to: data?.user_id,
            invited_to_name: data?.name,
            fee: data?.fee,
          }));
      }
      const invitePayload = {
        data: status === "INVITE-ALL" ? updatedSelectedInfluencer : selectedInfluencer,
        auction_id: auctionId,
        auction_name: auctionName,
      };
      const inviteRes = await createInfluencerInvitation(invitePayload);
      if (inviteRes?.status === 200 || inviteRes?.status === 201) {
        setUpdate(!update);
        setModalOpen(false);
        toast.success(inviteRes?.message);
      }
      else {
        setModalOpen(false);
        toast.error(inviteRes?.message);
        console.log(inviteRes, "Create Influencer Api Error");
      }
    } catch (error) {
      setModalOpen(false);
      console.log("Error in CreateInfluencer Api", error);
    }
  };

  // ==================== COMMON MODAL STATES {INVITE,INVITE-SELECTED,INVITE-ALL}  ====================
  const handleModal = (status, data) => {
    setModalOpen(true);
    try {
      if (status === "INVITE") {
        setModalData({
          title: "INVITE",
          onConfirm: () => handleInviteSingle(data),
        });
      } else if (status === "INVITE-ALL") {
        // handleSelectAll();
        setModalData({
          title: "INVITE-ALL",
          // onConfirm: () => handleInvite("INVITE-ALL"),
          onConfirm: handleAllInfluencerV2,
        });
      } else if (status === "INVITE-SELECTED") {
        setModalData({
          title: "INVITE-SELECTED",
          onConfirm: () => handleInvite("INVITE-SELECTED"),
        });
      } else {
        return null;
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  // ====================  HANDLE TABS ====================
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setPageAll(1);
    setPageInfluencer(1);
  };

  // *********** INFLUENCER NAVIGATION PROFILE ***********
  const handleNavigate = (data) => {
    const detailData = {
      auctionId: auctionId,
      auctionName: auctionName,
      userId: data?.user_id,
      invitationStatus: data?.invitationStatus,
      inviteFee: data?.fee
    };
    navigate('/influncer-ratings', { state: detailData });
  };

  // *********** HANDLE PAGE {ALL} ***********
  const handlePageAll = ({ selected }) => {
    setPageAll(selected + 1);
  };
  // *********** HANDLE PAGE {INFLUENCER} ***********
  const handlePageInfluencer = ({ selected }) => {
    setPageInfluencer(selected + 1);
  };

  // *********** HANDLE ALL INFLUENCER V2 ***********
  const handleAllInfluencerV2 = async () => {
    try {
      const inviteAllResV2 = await inviteAllInfleuencerV2(state?.auctionId);
      if (inviteAllResV2?.status === 200 || inviteAllResV2?.status === 201) {
        setUpdate(!update);
        setModalOpen(false);
        toast.success(inviteAllResV2?.message);
      }
      else {
        setUpdate(!update);
        setModalOpen(false);
        toast.error(inviteAllResV2?.message);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <div className="influence_auction_list_page">
      <h2>
        Influencer / <span>{state?.auctionName||''} - Auction {state?.auctionId||''}</span>
      </h2>
      <div className="page_desc">
        <p>
          Choose influencers from our list who have already joined our network
          to promote auctions similar to yours. If the influencer you're looking
          for isn't on the list, you can invite them to join as an external
          influencer. Once they join our network, they will automatically be
          included in your auction.
        </p>
        <p>Payment to influencers is solely success based on auction results</p>
      </div>
      <div className="page_tabs">
        <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
          <Nav>
            <Nav.Item>
              <Nav.Link eventKey="all">All</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="my_influencers">My Influencers</Nav.Link>
            </Nav.Item>
          </Nav>
          <hr className="custom_hr" />
          <Tab.Content>
            <Tab.Pane eventKey="all">
              {loading ? (
                <Loading />
              ) : (
                <>
                  <Table responsive className="custom_table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Rating</th>
                        <th>Fee Based on Monthly Listeners</th>
                        <th>Social Impact</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeInfluencer &&
                        activeInfluencer?.rows?.length > 0 ? (
                        activeInfluencer?.rows?.map((data) => (
                          <tr>
                            <td>
                              {data?.invitationStatus === null && (
                                <input
                                  type="checkbox"
                                  checked={selectedInfluencer.some(
                                    (item) => item.invited_to === data.user_id
                                  )}
                                  onChange={(e) =>
                                    handleInviteSelected(e, data)
                                  }
                                />
                              )}
                              <Link onClick={(e) => {
                                e.preventDefault();
                                handleNavigate(data);
                              }}>{data?.name ? data?.name : "N/A"}</Link>
                            </td>
                            <td>
                              {data?.rating === 0
                                ? "N/A"
                                : Array.from({ length: data?.rating }).map(
                                  (_, index) => (
                                    <StarIcon
                                      className="star_icon active"
                                      key={index}
                                    />
                                  )
                                )}
                            </td>
                            <td>{data?.fee}%</td>
                            <td>Large</td>
                            {data?.invitationStatus === null ? (
                              <td>
                                <button
                                  type="button"
                                  className="action_btn invite_btn"
                                  onClick={() => {
                                    // setSingleInfluencer(data);
                                    handleModal("INVITE", data);
                                  }}
                                >
                                  Invite
                                </button>
                              </td>
                            ) : data?.invitationStatus === "REJECTED" ? (
                              <td>
                                <button
                                  type="button"
                                  className="action_btn declined_btn"
                                >
                                  Declined
                                </button>
                              </td>
                            ) : data?.invitationStatus === "PENDING" ? (
                              <td>
                                <button
                                  type="button"
                                  className="action_btn pending_btn"
                                >
                                  Pending
                                </button>
                              </td>
                            ) : data?.invitationStatus === "ACCEPTED" ? (
                              <td>
                                <button
                                  type="button"
                                  className="action_btn accepted_btn"
                                >
                                  Accepted
                                </button>
                              </td>
                            ) : (
                              ""
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: "center" }}>
                            No record found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {activeInfluencer?.count > limit && (
                    <CMAuctions>
                      <section className="pagination custom_pagination">
                        <ReactPaginate
                          breakLabel="..."
                          nextLabel=""
                          previousLabel=""
                          onPageChange={handlePageAll}
                          pageRangeDisplayed={3}
                          forcePage={pageAll-1}
                          pageCount={Math.ceil(activeInfluencer?.count / limit)}
                          renderOnZeroPageCount={null}
                        // previousClassName={pageAll === 0 ? "disabled" : ""}
                        // nextClassName={
                        //   pageAll ===
                        //     Math.ceil(activeInfluencer?.count / limit)
                        //     ? ""
                        //     : ""
                        // }
                        />
                      </section>
                    </CMAuctions>
                  )}
                  <button
                    type="button"
                    className="action_btn invite_selected_btn"
                    onClick={() => handleModal("INVITE-SELECTED", "")}
                    disabled={!selectedInfluencer?.length > 0}
                  >
                    Invite Selected
                  </button>
                  <button
                    type="button"
                    className="action_btn invite_all_btn"
                    onClick={() => handleModal("INVITE-ALL", "")}
                    disabled={activeInfluencer?.rows?.length === 0}
                  >
                    Invite All
                  </button>
                  <h4 className="not_on_txt">Not on our list?</h4>
                  <button
                    type="button"
                    onClick={() => setShow(true)}
                    className="action_btn invite_all_btn invite_external_btn"
                  >
                    Invite External
                  </button>
                  <InviteExternalInfluencer
                    show={show}
                    auctionId={auctionId}
                    auctionName={auctionName}
                    handleClose={() => setShow(false)}
                    screenShot={state?.influencer_Screenshot}
                  />
                  <button type="button" className="action_btn back_btn" onClick={()=>navigate('/dashboard')}>
                    Back to my Auction
                  </button>
                </>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="my_influencers">
              <Table responsive className="custom_table">
                <thead>
                  <tr>
                    <th></th>
                    <th>(Converted/Total Traffic)</th>
                    <th>Conversion</th>
                    {/* <th>Current Commission</th> */}
                  </tr>
                </thead>
                <tbody>
                  {acceptedInfluencer && acceptedInfluencer?.rows?.length > 0 ?
                    acceptedInfluencer?.rows?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item?.invited_to_name ? item?.invited_to_name : "N/A"}</td>
                          <td>{`(${item?.converted_traffic}/${item?.total_traffic})`}</td>
                          <td>{item?.conversion ? item?.conversion : 0}</td>
                          {/* <td>
                          {item?.total_earning
                            ? `$${item?.total_earning}`
                            :'$'+ 0}
                        </td> */}
                        </tr>
                      );
                    }) :
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        No record found
                      </td>
                    </tr>}
                  {acceptedInfluencer && acceptedInfluencer?.count > 0 && <tr className="expected_commission_row">
                    <td>Expected Commission</td>
                    <td>
                      {`(${acceptedInfluencer?.outerData?.converted_traffic}/${acceptedInfluencer?.outerData?.total_traffic})`}
                    </td>
                    <td>{acceptedInfluencer?.outerData?.conversion || "0%"}</td>
                    {/* <td>
                    {acceptedInfluencer?.total_earning
                      ? `$${acceptedInfluencer?.total_earning}`
                      : "$" + 0}
                  </td> */}
                  </tr>}
                </tbody>
              </Table>
              {acceptedInfluencer?.count > limit && (
                <CMAuctions>
                  <section className="pagination custom_pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=""
                      previousLabel=""
                      forcePage={pageInfluencer-1}
                      onPageChange={handlePageInfluencer}
                      pageRangeDisplayed={3}
                      pageCount={Math.ceil(acceptedInfluencer?.count / limit)}
                      renderOnZeroPageCount={null}
                    />
                  </section>
                </CMAuctions>
              )}
              <button type="button" className="action_btn back_btn" onClick={()=>navigate('/dashboard')}>
                Back to my Auction
              </button>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        {modalOpen && (
          <Modal
            show={modalOpen}  
            centered
            backdropClassName="invite_external_influencer_modal_bg"
            className="invite_confirmation_modal"
          >
            <button
              onClick={() => setModalOpen(false)}
              className="cross_btn"
              type="button"
            >
              <CrossIcon />
            </button>
            <h3>{modalData?.title} REQUEST</h3>
            <p className="desc_txt">
              {modalData.title === "INVITE" &&
                "Do you want to invite this influencer?"}
              {modalData.title === "INVITE-ALL" &&
                "Do you want to invite all influencers?"}
              {modalData.title === "INVITE-SELECTED" &&
                "Do you want to invite the selected influencers?"}
            </p>
            <div className="d-flex align-items-center justify-content-center">
              <button
                className="cancel_btn custom_btn me-3"
                onClick={() => {
                  setSelectedInfluencer([]);
                  setModalOpen(false);
                }}
              >
                No{" "}
              </button>
              <button
                className="green_btn custom_btn"
                onClick={modalData?.onConfirm}
              >
                Yes{" "}
              </button>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default InfluenceAuctionListPage;
